import {useEffect, useMemo, useState} from "react";
import GHIconButton from "../../../../components/GHIconButton";
import CustomService from "../../../../services/custome.service";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import {closureColumns, dayNames} from "../../../../components/Utils/HeaderColumns";

const repeatLabels = {
  none: "Does not repeat",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  holiday: "Every holiday",
};

const formatRepeat = (element) => {
  const repeatType = element.repeat_type || "none";
  if (repeatType !== "weekly") {
    return repeatLabels[repeatType] || repeatLabels.none;
  }
  const days = (element.repeat_days || "")
    .split(",")
    .map((day) => dayNames[parseInt(day, 10)])
    .filter(Boolean)
    .join(", ");
  return days ? `Weekly: ${days}` : repeatLabels.weekly;
};

export function useLoadDataTable(clickItem, editItem, toggleStatusItem) {

  const [rows, setRows] = useState([]);
  const [columns] = useState(closureColumns); 

  useEffect(() => {
    CustomService.getClosures()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns: columns,
    rows: rows
      ? rows.map((element) => ({
          date: element.closure_date,
          repeat: formatRepeat(element),
          repeat_until: element.repeat_until || "-",
          start: element.closure_start_time,
          end: element.closure_end_time,
          amenity: element.amenity?.name,
          status: element.status,
          action: (
            <>
              <GHIconButton
                onClick={() => editItem(element)}
                id={element.id}
                title="Edit"
                icon="edit"
                size="small"
                color="warning"
              />
              <GHIconButton
                onClick={() => toggleStatusItem(element)}
                id={element.id}
                title={element.status === "active" ? "Deactivate" : "Activate"}
                icon={element.status === "active" ? "toggle_on" : "toggle_off"}
                size="small"
                color={element.status === "active" ? "success" : "secondary"}
              />
              <GHIconButton
                onClick={clickItem}
                id={element.id}
                title="Delete"
                icon="delete"
                size="small"
                color="error"
              />
            </>
          ),
        }))
      : [],
  };
}
